import React from 'react'
import {useTranslation} from 'react-i18next'
import {observer} from 'mobx-react'
import {Col, Row, Typography} from 'antd'
import {Button, Icon} from '@/components'
import {DownloadPdfForm, LinkPdfPreview} from '@/pages/PayByLink/components'
import {BACK_TO_LINK_DETAILS_BUTTON} from '@/constants/playwright-ids'
import {WarningOutlined} from '@ant-design/icons'
import {DownloadPdfProps} from './props'

import styles from './styles.scss'

export const DownloadPdf: React.FC<DownloadPdfProps> = observer(
    ({form, formId, paymentLink, terminalSettings, onBackToLinkClick, onDownloadButtonClick}) => {
        const {t} = useTranslation()

        return (
            <div className={styles.body}>
                <Button
                    className={styles.backBtn}
                    icon={<Icon type={'back_arrow_with_tail'} />}
                    type={'link'}
                    onClick={onBackToLinkClick}
                    data-test-id={BACK_TO_LINK_DETAILS_BUTTON}
                >
                    {t('LinkShare.backToLinkDetails')}
                </Button>
                <Row gutter={[32, 16]}>
                    <Col xs={24} md={12}>
                        <DownloadPdfForm
                            paymentLink={paymentLink}
                            terminalSettings={terminalSettings}
                            form={form}
                            formId={formId}
                            onDownloadButtonClick={onDownloadButtonClick}
                        />

                        <div className={styles.notice}>
                            <div className={styles.noticeTitle}>
                                <WarningOutlined className={styles.noticeIcon} />{' '}
                                {t('DownloadPdf.securityNoticeTitle')}
                            </div>

                            <Typography.Paragraph>
                                {t('DownloadPdf.securityNoticeParagraph')}
                            </Typography.Paragraph>

                            <ul className={styles.noticeList}>
                                <li>{t('DownloadPdf.securityNoticeList.item1')}</li>
                                <li>{t('DownloadPdf.securityNoticeList.item2')}</li>
                                <li>{t('DownloadPdf.securityNoticeList.item3')}</li>
                                <li>{t('DownloadPdf.securityNoticeList.item4')}</li>
                                <li>{t('DownloadPdf.securityNoticeList.item5')}</li>
                                <li>{t('DownloadPdf.securityNoticeList.item6')}</li>
                            </ul>
                        </div>
                    </Col>
                    <Col xs={24} md={12}>
                        <LinkPdfPreview form={form} paymentLink={paymentLink} />
                    </Col>
                </Row>
            </div>
        )
    }
)
